// extracted by css-extract-rspack-plugin
export default {"yellow":"yellow-xGSsOx","root":"root-DHOdFW","accent":"accent-bl8WWa","title":"title-bA0z38","cta":"cta-uAp_t2","pic":"pic-TFH2lx"};